import Toolbar from './Toolbar';
export default Toolbar;



// WEBPACK FOOTER //
// ./src/js/Toolbars/index.js